import { render } from "./ServicesDatatableActionsArchive.vue?vue&type=template&id=378a6204"
import script from "./ServicesDatatableActionsArchive.vue?vue&type=script&lang=js"
export * from "./ServicesDatatableActionsArchive.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__